<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title border-0 pb-0">فرم ارزیابی کالیبراسیون برای شماره حکم '{{inner_Calibration.letterRequestSchduleCustomer_id}}'</h5>

    <div class="row">
      <div class="form-group col-md-6">
        <button  *ngIf="!InProccessing" type="button" (click)="OnSubmit()" class="btn btn-success" style="margin-left: 5px;"><i
            class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
            <button (click)="OnSet_Back_CalibrationList()" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i>
              بازگشت </button>
        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
    </div>

    <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th></th>
              <th></th>

            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Evaluate">
             <td>{{DataList_Evaluate.indexOf(item)+1}}</td>
             <td>{{item.title}}</td>
             <td>
                <select class="custom-select"  [(ngModel)]="item.dsc">
                  <option value="0">انتخاب کنید</option>
                  <option value="1">خوب</option>
                  <option value="2">متوسط</option>
                  <option value="3">ضعیف</option>
                </select>
             </td>
            </tr>
          </tbody>
        </table>
    </div>

  </div>
</div>
